<template>
  <div ref="swiper" class="swiper" :class="extraClass">
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
      <!-- Slides -->
      <slot name="slides"></slot>
    </div>

    <!-- If we need pagination -->
    <slot name="pagination">
      <div class="swiper-pagination" v-if="hasPagination"></div>
    </slot>

    <!-- If we need navigation buttons -->
    <slot name="navigation">
      <div class="swiper-button-prev" v-if="hasNavigation"></div>
      <div class="swiper-button-next" v-if="hasNavigation"></div>
    </slot>
    <!-- If we need scrollbar -->
    <div class="swiper-scrollbar"></div>
  </div>
</template>

<script>
import Swiper, {Navigation, Pagination, Zoom, Lazy, Keyboard, FreeMode, Autoplay} from "swiper";

export default {
  name: "SwiperSlider",
  data() {
    return {
      instance: null
    }
  },
  props: {
    page: {
      type: Number,
      default: 1,
      required: false
    },
    extraClass: {
      type: String,
      default: '',
      required: false
    },
    slidesPerView: {
      type: [Number, String],
      default: 1,
      required: false
    },
    slidesPerGroup: {
      type: Number,
      default: 1,
      required: false
    },
    spaceBetween: {
      type: Number,
      default: 0,
      required: false
    },
    breakpoints: {
      type: Object,
      required: false
    },
    hasPagination: {
      type: Boolean,
      default: false,
      required: false
    },
    hasNavigation: {
      type: Boolean,
      default: false,
      required: false
    },
    hasScrollbar: {
      type: Boolean,
      default: false,
      required: false
    },
    loop: {
      type: Boolean,
      default: true,
      required: false
    },
    selectedIndex: {
      type: Number,
      default: 0,
      required: false
    },
    zoom: {
      type: Boolean,
      default: false,
      required: false
    },
    lazy: {
      type: Boolean,
      default: true,
      required: false
    },
    keyboard: {
      type: Boolean,
      default: true,
      required: false
    },
    cssMode: {
      type: Boolean,
      default: false,
      required: false
    },
    freeMode: {
      type: Boolean,
      default: false,
      required: false
    },
    autoplay: {
      type: Boolean,
      default: false,
      required: false
    },
    simulateTouch: {
      type: Boolean,
      default: true,
      required: false
    },
    grabCursor: {
      type: Boolean,
      default: true,
      required: false
    },
  },
  watch: {
    page() {
      this.update()
    }
  },

  mounted() {
    this.instance = this.initSwiper()
  },

  destroyed() {
    this.instance.destroy()
  },

  methods: {
    initSwiper() {
      let self = this
      let firstClick = true
      const modules = {
        modules: [
          ...this.hasNavigation ? [Navigation] : [],
          ...this.hasPagination ? [Pagination] : [],
          ...this.zoom ? [Zoom] : [],
          ...this.lazy ? [Lazy] : [],
          ...this.keyboard ? [Keyboard] : [],
          ...this.freeMode ? [FreeMode] : [],
          ...this.autoplay ? [Autoplay] : [],
        ]
      }

      const events = {
        on: {
          init: function () {
            self.$emit('swiper-init')
          },
          lazyImageReady: function (swiper, slideEl, imageEl) {
            // console.log('lazy  ', swiper, slideEl, imageEl)
          },
          slideChange: function (swiper) {
            let index = swiper.realIndex

            // Due to a swiper strange calculation (bug?) the first realIndex is wrong (+1) when option loop===true
            if (firstClick && self.loop) index -= 1
            firstClick = false
            self.$emit('slide-change', index, swiper)

          },
        },
      }

      const behaviour = {
        simulateTouch: this.simulateTouch,
        slidesPerView: this.slidesPerView,
        spaceBetween: this.spaceBetween,
        slidesPerGroup: this.slidesPerGroup,
        cssMode: this.cssMode,
        freeMode: this.freeMode,
        grabCursor: this.grabCursor,
        breakpoints: this.breakpoints,
        ...(this.lazy && {
          lazy: {
            loadPrevNext: true,
          }
        }),
        loop: this.loop,
        initialSlide: this.selectedIndex,
        zoom: this.zoom,
        keyboard: this.keyboard,
        ...(this.autoplay && {
          autoplay: {
            delay: 2500,
            disableOnInteraction: true
          }
        }),
      }

      const options = {
        ...modules,
        ...behaviour,
        ...events,
        ...(this.hasPagination && {
          pagination: {
            el: '.swiper-pagination'
          }
        }),
        ...(this.hasNavigation && {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        }),
        ...(this.hasScrollbar && {
          scrollbar: {
            el: '.swiper-scrollbar',
          }
        })
      }

      return new Swiper(this.$refs.swiper, options)
    },
    update() {
      this.instance.update()
    },
  }
}
</script>

